import { FitnessCenter } from '@mui/icons-material';
import { Grid, Card, CardContent, Typography, Stack, Box } from '@mui/material';
import Fieldset from '../../components/Fieldset';
import { ImageFromServer } from '../../components/images/ImageFromServer';
import { ExerciseDTO } from '@/generated';
import { useBodyZoneListQuery, useEquipmentListQuery } from '@/hooks/query-hooks';
import { PrimaryValueIcon } from '@/components/PrimaryValueIcon';

interface CardExerciseProps {
  exercise: ExerciseDTO;
  timeout: number;
  onClick?: () => void;
}

export const ExerciseCardGridElement = (props: CardExerciseProps) => {
  return (
    <Grid size={{ md: 4, xs: 12, sm: 6 }} sx={{ justifyItems: 'center' }}>
      <ExerciseCard onClick={props.onClick} {...props} />
    </Grid>
  );
};

export const ExerciseCard = (props: CardExerciseProps) => {
  const { equipmentList } = useEquipmentListQuery();
  const { bodyZoneList } = useBodyZoneListQuery();
  const { exercise } = props;
  return (
    <Card onClick={props.onClick} sx={{ cursor: 'pointer', minHeight: 150, maxWidth: 450, height: '100%' }}>
      <CardContent sx={{ height: '100%' }}>
        <Grid sx={{ height: '100%' }} container>
          <Grid size={5}>
            <ImageFromServer sx={{ flex: 1, maxWidth: 100, maxHeight: 100 }} thumbnail={true} alt="" id={exercise.imageId} />
          </Grid>
          <Grid size={7}>
            <Typography sx={{ overflowWrap: 'break-word', flex: 1 }} variant="h6">
              {props.exercise.name}
            </Typography>
            <Typography sx={{ py: 0.2 }} variant="body2">
              {bodyZoneList?.find((bz) => bz.id === props.exercise.mainBodyZoneId)?.name ?? 'N.A.'}
            </Typography>
            <Grid container>
              <Grid size={4}>
                <Stack direction={'row'} gap={1} sx={{ m: 1 }}>
                  <FitnessCenter fontSize="small" />
                  <Typography variant="body2">{props.exercise.config?.weight || '-'}</Typography>
                </Stack>
              </Grid>
              <Grid size={4}>
                <Stack direction={'row'} gap={1} sx={{ m: 1 }}>
                  <PrimaryValueIcon executionType={props.exercise.config.executionType} />
                  <Typography variant="body2">{props.exercise.config.value ?? '-'}</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={12}>
            <Stack sx={{ width: '100%', height: '100%', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
              {props.exercise.equipment.length > 0 && (
                <Box sx={{ width: '100%' }}>
                  <Fieldset title="Equipment">
                    <Typography>
                      {props.exercise.equipment.map((ec, i) => `${i ? ',' : ''} ${equipmentList?.find((e) => e.id === ec.equipmentId)?.name} ${ec.optional ? ' (Opt.)' : ''}`)}
                    </Typography>
                  </Fieldset>
                </Box>
              )}
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
